import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { userApi } from '../../components/common/User/userApi';

interface AuthState {
  isUnauthorized: boolean;
  unauthorizedMessage: string | null;
  authenticatedUserSub: string | null;
}

const initialState: AuthState = {
  isUnauthorized: false,
  unauthorizedMessage: null,
  authenticatedUserSub: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUnauthorized: (state, action: PayloadAction<string | undefined>) => {
      state.isUnauthorized = true;
      state.unauthorizedMessage = action.payload ?? null;
      state.authenticatedUserSub = null;
    },
    clearUnauthorized: (state) => {
      state.isUnauthorized = false;
      state.unauthorizedMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      userApi.endpoints.getUserInfo.matchFulfilled,
      (state, { payload }) => {
        state.authenticatedUserSub = payload.sub ?? null;
      }
    );

    builder.addMatcher(userApi.endpoints.getUserInfo.matchRejected, (state) => {
      state.authenticatedUserSub = null;
    });
  },
});

export const { setUnauthorized, clearUnauthorized } = authSlice.actions;

export default authSlice.reducer;
